import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { adminClient } from '../../api'
import { AdminNotice } from './adminShared'
import { describeAdminError, type AdminFeedback } from './adminHelpers'
/**
 * Equivalent of legacy `AdminStrategyListComponent` (route `admin/strategies`,
 * contract #13). ARCHIVE: the `bc_` Strategy namespace has no writer in
 * either the legacy or the rewritten backend, so this always answers `[]` —
 * kept for completeness, not because there is live data behind it.
 */
export function AdminStrategyListPage() {
  const [strategies, setStrategies] = useState<{ id: string }[] | null>(null)
  const [feedback, setFeedback] = useState<AdminFeedback | undefined>()

  useEffect(() => {
    let cancelled = false
    adminClient
      .strategies()
      .then((rows) => {
        if (!cancelled) setStrategies(rows as { id: string }[])
      })
      .catch((err) => {
        if (!cancelled) setFeedback(describeAdminError(err))
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div>
      <div className="portal-page-title">
        <h1>Admin — strategies</h1>
      </div>
      <div className="portal-card">
        <p className="portal-notice portal-notice--info">
          ARCHIVE — the strategy-subscription namespace has no active writer; this list is expected to be empty.
        </p>
        <AdminNotice feedback={feedback} />
        {strategies === null && !feedback && <p>Loading…</p>}
        {strategies !== null && strategies.length === 0 && <p className="portal-text-muted">No strategies found.</p>}
        {strategies !== null && strategies.length > 0 && (
          <ul>
            {strategies.map((s) => (
              <li key={s.id}>
                <Link to={`/admin/strategies/${encodeURIComponent(s.id)}`}>{s.id}</Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}
